import {MenuItemInterface} from './menu';

// 没多少数据， 直接找， 同样的， 按2级菜单处理
const findMenuByPath = (path: string, menu: MenuItemInterface[]) => {
  for (let i = 0; i < menu.length; i++) {
    const item = menu[i];
    if (item.path === path) {
      return item;
    }
    if (item.children) {
      for (let j = 0; j < item.children.length; j++) {
        const subItem = item.children[j];
        if (subItem.path === path) {
          return subItem;
        }
      }
    }
  }
};

export {
  findMenuByPath
};
